<script>
import axios from "axios";

import Layout from "../../layouts/auth";
// import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";
/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Update Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      emailError:"",
      passwordError:"",
      isResetting:false,
    
      update:{
        email: localStorage.getItem("email"),
        password: '',
        confirm: '',    
      }
    };
  },
  methods: {
    resetPassword(){
      this.isResetting=true;
      if (this.update.password.length < 5){
        this.passwordError="Please enter a strong password of at least 5 characters";
        this.isResetting=false;
        return;
      }else {
        this.passwordError="";
      }

      if (this.update.password != this.update.confirm){
        this.passwordError="Password do not match. Try again";
        this.isResetting=false;
        return;
      }else {
        this.passwordError="";
      }

      axios.post('newuser/update_password', this.update).then(response => {
        if (response.status==200){
          localStorage.removeItem('email');
          localStorage.setItem("token", response.data.token)
          const token = response.data.token
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;  
          this.$router.push('/');
        }else {
          this.passwordError="Password updating failed. Try again";
        }
      }).catch(()=>{
        this.passwordError="Password updating failed. Try again";
      })

    },
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">

          <div class="card-body pt-0">
            <div>
                <div class="row">
                  <div class="col-md-2">
                    <div class="avatar-md profile-user-wid mt-3">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logomain.png" alt height="40" />
                  </span>

                    </div>
                  </div>
                  <div class="col-md-10">
                    <div class="text-primary p-4">
                      <h4 class="text-primary">SET NEW PASSWORD</h4>
                      <p style="color:orange">Enter your new password, this will be used on the next login so you need to note it.</p>
                    </div>
                  </div>
                </div>
            </div>
          
            <!-- create new password -->
            <div class="p-2" id="password-card" style="display: block">
              <form @submit.prevent="resetPassword">                
                <div class="mb-3">
                <label for="userEmail">New Password</label>
                  <input type="password" required v-model="update.password" class="form-control"
                         placeholder="Enter new password"/>
                </div>
                <div class="mb-3">
                <label for="userEmail">Confirm Password</label>
                  <input type="password" required v-model="update.confirm" class="form-control"
                         placeholder="Confirm password"/>
                </div>
                <div class="mt-3 d-grid">
                  <b-button type="submit" variant="primary" class="btn-block">
                    Update Password
                    <b-spinner v-if="isResetting==true" variant="light" small role="status"></b-spinner>
                  </b-button>
                </div>
              </form>
            </div>
            <!-- end create new password -->
        </div>

        </div>
        <!-- end card -->

        <div class="mt-2 text-center">
          <p>
            <router-link tag="a" to="/login" class="fw-medium text-primary"><i class="fa fa-arrow-left"></i> Back to login</router-link>
          </p>
          <p>© {{ new Date().getFullYear() }} Clinicplus. Developed
            <a target="_blank" href="#"> Nugsoft Technologies</a>
          </p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
